// Dependencies
require("webstrap/type");
require("webstrap/forms");
require("webstrap/buttons");
require("grid");
require("section/generic");
require("element/rich-text");

// JavaScript
var $ = require("jquery");


// If the newsletter is in the page
$('.sec-newsletter-form').each(function (e) {
    var $sec = $(this);
    var $form = $('form', $sec);
    var $msg = $('.sec-newsletter-form__msg', $sec);
    var successRedirect = $sec.data("success-redirect");
    $('#mce-EMAIL').val(getParameterByName("EMAIL"));

    // Form validation (setup for manual validation)
    require("forms-validation");
    $form.validate(require("forms-validation/options/defaults.js"));
});

function getParameterByName(name) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/newsletter-form/index.js
 ** module id = 185
 ** module chunks = 0 1
 **/